import ax from 'axios'

// insert all your axios logic here

export const axios = ax

if (process.env.NODE_ENV === 'development') {
    ax.defaults.baseURL = 'https://cadflo.ru/';
} else {
    ax.defaults.baseURL = '';
}


export default {
    install(Vue, options) {
        Vue.prototype.$axios = ax
    }
}